import React from 'react';
import { Link } from 'react-router-dom';
import './ProductEcosystem.css';
import WorkcrtlLogo from '../assets/images/Workctrl-logo.png';

const products = [
  {
    icon: '🏗️',
    category: 'Facility Management & IoT',
    name: 'BMS',
    accent: 'var(--orange)',
    desc: 'Building Management System with IoT integration — providing centralized control and real-time monitoring of lighting, HVAC, energy consumption, parking, facility bookings, maintenance operations, and building compliance across multi-tenant facilities.',
    tags: ['IoT Device Management', 'Light Control (LCS)', 'AC & Climate Control', 'Energy Monitoring', 'Smart Meters', 'Facility Bookings', 'Parking Management', 'Building Compliance', 'Real-time Firebase', 'Multi-location', 'OTP Authentication', 'Diesel Consumption', 'Multi-tenant'],
    subItems: [
      { emoji: '💡', label: 'Lighting Control' },
      { emoji: '❄️', label: 'HVAC Control' },
      { emoji: '⚡', label: 'Energy Mgmt' },
      { emoji: '🔧', label: 'R&M' },
      { emoji: '🅿️', label: 'Parking' },
      { emoji: '📅', label: 'Room Booking' },
      { emoji: '🌡️', label: 'Temp Sensors' },
      { emoji: '📋', label: 'Compliance' },
      { emoji: '📊', label: 'KPI Dashboard' },
      { emoji: '🐛', label: 'Snag List' },
      { emoji: '📝', label: 'Site Reports' },
      { emoji: '🔌', label: 'Meter Mgmt' },
      { emoji: '🔐', label: 'Access Control' },
    ],
  },
  {
    icon: '🤝',
    category: 'Customer Relationship Management',
    name: 'CRM',
    accent: 'var(--pink)',
    desc: 'Enterprise CRM and business management portal for commercial real estate — managing the complete lifecycle of leads, sales pipelines, smart proposals, client agreements, broker relationships, property operations, occupancy tracking, and financial accounting with multi-level approval workflows.',
    tags: ['Lead Management', 'Sales Pipeline', 'Smart Proposals', 'Client Management', 'Broker Management', 'Approval Workflows', 'Accounting & GL', 'Occupancy Tracking', 'Property Management', 'KYC Compliance', 'Multi-location', 'Analytics & BI'],
    subItems: [
      { emoji: '📊', label: 'Dashboard' },
      { emoji: '🎯', label: 'Lead Mgmt' },
      { emoji: '📝', label: 'Proposals' },
      { emoji: '🤝', label: 'Broker Hub' },
      { emoji: '🧾', label: 'Invoicing' },
      { emoji: '✅', label: 'Approvals' },
      { emoji: '📄', label: 'Agreements' },
      { emoji: '🏢', label: 'Occupancy' },
      { emoji: '📈', label: 'Daily Sales' },
    ],
  },
  {
    icon: '🏬',
    category: 'Workplace Management',
    name: 'CSPOC',
    accent: 'var(--cyan)',
    desc: 'Enterprise single-point-of-contact platform for workplace and facilities management — covering room booking, desk allocation, parking, visitor management, employee engagement, rewards, and 27+ ancillary services across multiple office locations.',
    tags: ['Meeting Room Booking', 'Desk Booking', 'Parking Management', 'Visitor Management', 'Rewards & Wallet', 'Survey & Feedback', 'Access Control', 'Ancillary Services', 'Multi-location Support', 'RFID Integration', 'Analytics & Reporting'],
    subItems: [
      { emoji: '🪑', label: 'Seat Booking' },
      { emoji: '🅿️', label: 'Parking' },
      { emoji: '🎁', label: 'Rewards' },
      { emoji: '🍽️', label: 'Meal Plans' },
      { emoji: '🎫', label: 'Ticketing' },
      { emoji: '📋', label: 'Compliance' },
      { emoji: '📅', label: 'Roster Mgmt' },
      { emoji: '👤', label: 'Employee Dir' },
      { emoji: '💳', label: 'Wallet Top-Up' },
    ],
  },
  {
    icon: '🏢',
    category: 'Account Management, Real Estate & Operations',
    name: 'Nexus',
    accent: 'var(--green)',
    desc: 'Unified enterprise platform for Account Management, Real Estate, and Building Operations — managing client 360 views, property leads & lease lifecycle, multi-level approval workflows, broker & landlord coordination, extended hours & after-hours booking, electricity & meter analytics, and operations dashboards with geographic heatmaps across multi-city locations.',
    tags: ['Client 360 View', 'Property Leads & Kanban', 'Lease Lifecycle', 'Agreements & Approvals', 'Broker & Landlord Mgmt', 'Extended Hours & After-Hours', 'Meter & Electricity Analytics', 'Geographic Heatmaps', 'Multi-city Locations', 'Keycloak SSO'],
    subItems: [
      { emoji: '👤', label: 'Client 360' },
      { emoji: '🏠', label: 'Property Leads' },
      { emoji: '📑', label: 'Agreements' },
      { emoji: '✅', label: 'Approvals' },
      { emoji: '🤝', label: 'Brokers' },
      { emoji: '📈', label: 'Lease Dashboard' },
      { emoji: '🕐', label: 'Extended Hours' },
      { emoji: '⚡', label: 'Meter Analytics' },
      { emoji: '🗺️', label: 'Geo Heatmaps' },
    ],
  },
  {
    icon: '🎟️',
    category: 'IT Service Management',
    name: 'Ticketing',
    accent: 'var(--pink)',
    desc: 'Enterprise-grade ticket management and support lifecycle platform — featuring multi-status workflows, SLA tracking, multi-level escalation, role-based hierarchy, dynamic form builder, and advanced analytics across multiple locations and departments.',
    tags: ['Ticket Tracking', 'SLA Management', 'Escalation Engine', 'Dynamic Workflows', 'Role-Based Access', 'Multi-location', 'Analytics & Insights', 'Keycloak SSO', 'Custom Form Builder', 'File Management'],
    subItems: [
      { emoji: '📊', label: 'Dashboard' },
      { emoji: '⚠️', label: 'Escalations' },
      { emoji: '⏱️', label: 'SLA Config' },
      { emoji: '👥', label: 'Hierarchy Mgmt' },
      { emoji: '🔍', label: 'Advanced Search' },
      { emoji: '⭐', label: 'Rating System' },
      { emoji: '🗂️', label: 'Category Mgmt' },
      { emoji: '💬', label: 'Comments' },
      { emoji: '📥', label: 'Export & Reports' },
    ],
  },
  {
    icon: '📈',
    category: 'Vendor Analytics & Management',
    name: 'Vendor Report',
    accent: 'var(--yellow)',
    desc: 'Comprehensive vendor dashboard and reporting platform — enabling multi-store sales tracking, financial settlement automation, loyalty & cashback management, product catalog control, store onboarding, and embedded BI analytics for retail and food-delivery vendors.',
    tags: ['Sales Analytics', 'Auto Settlement', 'Loyalty & Cashback', 'Product Catalog', 'Store Onboarding', 'Wallet Management', 'Invoice Validation', 'Payment Gateway', 'Export to Excel', 'Multi-store', 'GSTIN & Tax Compliance', 'Superset BI Dashboards'],
    subItems: [
      { emoji: '📈', label: 'Day Wise Sales' },
      { emoji: '🛒', label: 'Item Wise Sales' },
      { emoji: '💳', label: 'Settlements' },
      { emoji: '🎁', label: 'Cashback & Points' },
      { emoji: '🍽️', label: 'Meal Plans' },
      { emoji: '📦', label: 'Product Mgmt' },
      { emoji: '🏪', label: 'Store Ops' },
      { emoji: '🧾', label: 'Invoices' },
      { emoji: '📊', label: 'BI Dashboard' },
    ],
  },
  {
    icon: '🛒',
    category: 'Vendor POS & Store Operations',
    name: 'Smart Store',
    accent: 'var(--cyan)',
    desc: 'Multi-functional vendor management and point-of-sale platform for food and retail businesses — featuring real-time order processing, inventory control, sales analytics, payment verification, settlement tracking, product catalog management, and integrated bug tracking with Jira and screen recording.',
    tags: ['Point-of-Sale', 'Order Management', 'Inventory Control', 'Sales Analytics', 'Payment Verification', 'Settlement Tracking', 'Product Catalog', 'Firebase Real-time', 'Shopify Integration', 'Jira Bug Tracking', 'Meal Plan Reports', 'Mixpanel Analytics'],
    subItems: [
      { emoji: '🛒', label: 'POS Module' },
      { emoji: '📦', label: 'Inventory' },
      { emoji: '📈', label: 'Sales Reports' },
      { emoji: '💳', label: 'Payments' },
      { emoji: '🧾', label: 'Invoices' },
      { emoji: '🍽️', label: 'Meal Plans' },
      { emoji: '🐛', label: 'Bug Tracker' },
      { emoji: '📹', label: 'Screen Capture' },
      { emoji: '🔄', label: 'Settlements' },
    ],
  },
  {
    icon: '📱',
    category: 'Workspace Management & Building Ops',
    name: 'WorkCtrl',
    accent: 'var(--accent2)',
    desc: 'Unit-level control and tracking platform for granular visibility into every managed space — part of the Building Ops suite powering day-to-day workspace experience. Enables meeting room & conference room booking, support ticket management, food & essentials ordering from exclusive stores, live activity tracking, and real-time service status monitoring across Smartworks-powered properties.',
    tags: ['Unit-Level Control', 'Space Tracking', 'Meeting Room Booking', 'Support Tickets', 'Food & Essentials Ordering', 'Live Activity Tracking', 'Service Status Monitoring', 'Multi-location', 'Smartworks Powered'],
    subItems: [
      { emoji: '🏢', label: 'Room Booking' },
      { emoji: '🎫', label: 'Support Tickets' },
      { emoji: '🍽️', label: 'Food Ordering' },
      { emoji: '📊', label: 'Live Tracking' },
      { emoji: '🔍', label: 'Space Visibility' },
      { emoji: '🛒', label: 'Essentials Store' },
    ],
  },
  {
    icon: '🛂',
    category: 'Visitor Management',
    name: 'VMS',
    accent: 'var(--green)',
    desc: 'Multi-tenant visitor management platform for corporate facilities — handling visitor check-in/check-out, host notifications, facial recognition via AWS Rekognition, thermal camera monitoring, OTP verification, QR code passes, and visitor analytics with Excel & PDF reporting across multi-location offices.',
    tags: ['Visitor Check-in/Check-out', 'Facial Recognition', 'QR Code Passes', 'Thermal Camera', 'OTP Verification', 'Host Notifications', 'Visitor Analytics', 'Multi-tenant', 'Multi-location', 'AWS Integration'],
    subItems: [
      { emoji: '🛂', label: 'Check-in/Out' },
      { emoji: '👁️', label: 'Face Recognition' },
      { emoji: '📱', label: 'QR Passes' },
      { emoji: '🔔', label: 'Notifications' },
      { emoji: '📊', label: 'Analytics' },
      { emoji: '📷', label: 'Thermal Camera' },
      { emoji: '🔐', label: 'OTP Verify' },
      { emoji: '💬', label: 'Feedback' },
      { emoji: '📥', label: 'Excel & PDF' },
    ],
  },
];

function ProductCard({ product }) {
  return (
    <article className="pe-card" style={{ '--card-accent': product.accent }}>
      <div className="pe-card-icon">{product.icon}</div>
      <div className="pe-card-category">{product.category}</div>
      <h3>{product.name}</h3>
      <p className="pe-desc">{product.desc}</p>
      <div className="pe-tags">
        {product.tags.map((tag, i) => (
          <span className="pe-tag" key={i}>{tag}</span>
        ))}
      </div>
      <div className="pe-sub-grid">
        {product.subItems.map((item, i) => (
          <div className="pe-sub-item" key={i}>
            <span>{item.emoji}</span>{item.label}
          </div>
        ))}
      </div>
    </article>
  );
}

function ProductEcosystem() {
  return (
    <div className="product-ecosystem">
      {/* HERO */}
      <section className="pe-hero">
        <div className="pe-hero-badge">Product Ecosystem 2026</div>
        <h1>
          <img
            src={WorkcrtlLogo}
            alt="WorkCtrl"
            className="pe-hero-logo"
          />{' '}
          Product Ecosystem
        </h1>
        <p>
          Powering every stage of the workspace lifecycle — from real estate acquisition to building
          operations, vendor management, and workplace experience.
        </p>
      </section>

      {/* PRODUCTS */}
      <section className="pe-phase" id="products">
        <div className="pe-phase-inner">
          <div className="pe-phase-header">
            <div className="pe-phase-label">Our Products</div>
            <h2>Product Suite</h2>
            <p>Our integrated ecosystem of products powering every aspect of your operations.</p>
            <div className="pe-phase-header-line"></div>
          </div>
          <div className="pe-product-grid">
            {products.map((product, i) => (
              <ProductCard key={i} product={product} />
            ))}
          </div>
        </div>
      </section>

      {/* FOOTER */}
      <footer className="pe-footer">
        <p><strong>WORKCTRL</strong> &mdash; Integrated Workplace Management Systems</p>
        <p style={{ marginTop: '6px' }}>&copy; 2026 Smartworks Tech Solutions Pvt. Ltd. All rights reserved.</p>
      </footer>
    </div>
  );
}

export default ProductEcosystem;
